/**
 * "The visitor just sent something" as an explicit one-shot signal, set by the tab's send paths and
 * consumed by the scroll engine when the list grows. Growth alone cannot tell a send from older
 * history prepending or a refetch landing (both also grow the list, and the newest row is often the
 * visitor's), so only a real send may pull a scrolled-up reader to the new bubble.
 *
 * It expires: a send that never produced a row (deduped, failed before the row) must not claim a
 * later, unrelated arrival.
 */
export interface OwnSendSignal {
  mark(): void;
  /** True once per `mark()`, and only while it is fresh. */
  consume(): boolean;
}

const DEFAULT_TTL_MS = 5_000;

export function createOwnSendSignal(
  now: () => number = Date.now,
  ttlMs: number = DEFAULT_TTL_MS,
): OwnSendSignal {
  let markedAt: number | null = null;
  return {
    mark() {
      markedAt = now();
    },
    consume() {
      const fresh = markedAt !== null && now() - markedAt <= ttlMs;
      markedAt = null;
      return fresh;
    },
  };
}
